import { render, staticRenderFns } from "./UserLogo.vue?vue&type=template&id=02fdf0d6&scoped=true&"
import script from "./UserLogo.vue?vue&type=script&lang=js&"
export * from "./UserLogo.vue?vue&type=script&lang=js&"
import style0 from "./UserLogo.vue?vue&type=style&index=0&id=02fdf0d6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02fdf0d6",
  null
  
)

export default component.exports